import React from "react";
import Typography from "@material-ui/core/Typography";

import { TypographColor } from "./utils";
import { PlainLink } from "./PlainLink";

type Props = {
  color?: TypographColor;
  [other: string]: any;
  onClick?: (e: React.SyntheticEvent<any>) => void;
  // New click property will  come here
};

export const Title: React.FC<Props> = ({ color, onClick, children, ...rest }) => {
  // return onclick ? <div> {onClick} </div> : <div> {onClick} </div>;

  return onClick ? (
    <PlainLink inline onClick={onClick} variant="h6" color={color}>
      {children}
    </PlainLink>
  ) : (
    <Typography variant="h6" color={color} {...rest}>
      {children}
    </Typography>
  );
};

Title.defaultProps = {
  color: "inherit"
};

export default Title;
